import {PolicyStatusEnum} from "../../constants";

type PolicyInfo = {
    id: string;
    policyNumber: string | null;
    trancheNo: number | null;
    currentPolicyStatus: string | any;
    "strategy.id": number;
    "strategy.displayName": string;
    "strategy.name": string;
    "carrier.carrierName": string;
    "tranche.trancheNumber": number;
    "carrier.id": number;
}
export const getPolicyName = (policy:PolicyInfo) =>{
    if(policy &&  policy.currentPolicyStatus && [PolicyStatusEnum.InForce, PolicyStatusEnum.InForceOverride].includes(policy.currentPolicyStatus)){
        return `${policy["policyNumber"] || ""} - ${policy["strategy.name"]} - ${policy["carrier.carrierName"]} - ${policy["tranche.trancheNumber"]}T`
    }
    return `In Progress Enrollment-${policy["strategy.name"]}-${policy["carrier.carrierName"]}`
}

export const isPolicyIssued = (policy:PolicyInfo) => {
    return !!(policy && policy.currentPolicyStatus && [PolicyStatusEnum.InForce, PolicyStatusEnum.InForceOverride].includes(policy.currentPolicyStatus))
}